import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <div className="privacy">
      <div className="min-h-80vh px-4 lg-px-27px 2xl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs"><Link onClick={toTop} to="/">Home</Link><span className="px-2">/</span><span>Privacy Policy</span></div>
        </div>
        <article className="cms-root_cmsFullWidth-5e3 cms-root-63a px-4">
          <div className="richContent-root-63a"><div className="row-contained-645 row-root-63a row-contained-inner"><div className="text-root-63a">
            <h1>Privacy Policy</h1>
            <p className="p1">This policy explains how failblossom collects, uses, stores and shares personal information when you browse this website, contact us or place an order.</p>
            <h2>Information we collect</h2>
            <ul>
              <li>Contact and account details, such as your name, email, telephone number and delivery or billing address.</li>
              <li>Order and payment information. Payment card details are handled by our payment providers and are not stored in full by us.</li>
              <li>Messages, preferences, product reviews and customer-service history.</li>
              <li>Technical and usage information, including IP address, device, browser, pages viewed and cookie choices.</li>
            </ul>
            <h2>How we use information</h2>
            <p className="p1">We use information to fulfil orders, take payment, arrange delivery and returns, answer questions, prevent fraud, keep the site secure, meet legal obligations and improve our products and services. With your consent, we may also send marketing messages; you can unsubscribe at any time.</p>
            <h2>Our legal bases</h2>
            <p className="p1">Depending on the activity, we process information to perform a contract with you, comply with law, pursue legitimate interests such as site security and service improvement, or act on your consent.</p>
            <h2>Sharing and international transfers</h2>
            <p className="p1">We share only what is necessary with trusted providers supporting payments, hosting, analytics, customer service and delivery, and with authorities where required by law. If information is transferred internationally, we use an appropriate legal safeguard.</p>
            <h2>Retention and security</h2>
            <p className="p1">We keep personal information only as long as needed for the purpose collected, including tax, accounting, dispute and fraud-prevention requirements. We use proportionate technical and organisational safeguards, although no online service can guarantee absolute security.</p>
            <h2>Your rights</h2>
            <p className="p1">Depending on where you live, you may ask for access, correction, deletion, restriction, portability or objection, and may withdraw consent. You may also complain to your local data-protection authority. We may need to verify your identity before acting on a request.</p>
            <h2>Children</h2>
            <p className="p1">This website is not directed to children under 16, and we do not knowingly collect their personal information.</p>
            <h2>Cookies</h2>
            <p className="p1">For details about cookies and how to manage them, read our <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>.</p>
            <h2>Contact us</h2>
            <p className="p1">For privacy questions or rights requests, email <a href="mailto:level@failblossom.lifestyle">level@failblossom.lifestyle</a>.</p>
            <p className="p1">Correspondence address: 181 Piccadilly, London W1A 1ER, United Kingdom.</p>
            <p className="p1"><strong>Last updated: 14 September 2026</strong></p>
          </div></div></div>
        </article>
      </div>
    </div>
  );
}

export default Privacy;
